module.exports = __webpack_public_path__ + "ad34924db4fd5c93a560024c7ee81ab2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cylindre-laiton-nickele.jpg
// module id = 677
// module chunks = 0